import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Rekprof logo",
  class: "logo_min",
  src: "../../../../assets/logo.png"
}, null, -1)
const _hoisted_2 = { class: "inner_step_box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, "9. Данные о констукции", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left hint_mini_top" }, "Наличие и вид подсветки", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, "Габаритные размеры, м", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, "Размер информационного поля, м", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left hint_mini_top" }, "Количество информационных полей", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, "Размер информационного поля, м", -1)
const _hoisted_17 = ["value", "onInput", "onChange"]
const _hoisted_18 = ["value", "onInput", "onChange"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-trash" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_menu_list = _resolveComponent("v-menu-list")!
  const _component_v_select_open = _resolveComponent("v-select-open")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_v_menu_list),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        class: "main_input",
        placeholder: "Введите номер",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.storeDM.save_obj.number_type_illumination) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.number_type_illumination]
      ]),
      _hoisted_5,
      _hoisted_6,
      _withDirectives(_createElementVNode("input", {
        class: "first_input",
        placeholder: "Введите ширину",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.storeDM.save_obj.construction_width) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.construction_width]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "two_input",
        placeholder: "Введите высоту",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.storeDM.save_obj.construction_height) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.construction_height]
      ]),
      _hoisted_7,
      _hoisted_8,
      _withDirectives(_createElementVNode("input", {
        class: "first_input",
        placeholder: "Введите ширину",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.storeDM.save_obj.construction_info_width) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.construction_info_width]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "two_input",
        placeholder: "Введите высоту",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.storeDM.save_obj.construction_info_height) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.construction_info_height]
      ]),
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      (_openBlock(), _createBlock(_component_v_select_open, {
        options: _ctx.fieldcounts_options,
        title_select: _ctx.fieldcounts_title,
        default_select: _ctx.storeDM.save_obj.info_count,
        key: _ctx.storeDM.save_obj.info_count,
        onChangeSelect: _ctx.fieldcounts_select,
        margin_top: '-6px'
      }, null, 8, ["options", "title_select", "default_select", "onChangeSelect"])),
      _hoisted_12,
      _hoisted_13,
      _hoisted_14,
      _createElementVNode("button", {
        class: "blue_btn",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.info_field_add && _ctx.info_field_add(...args))),
        style: {"float":"left","margin-left":"10px"}
      }, " Добавить дополнительный размер информационного поля "),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeDM.save_obj.construction_info_custom, (input, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _hoisted_15,
            _hoisted_16,
            _createElementVNode("input", {
              class: "first_sm_input",
              placeholder: "Введите ширину",
              value: input[0],
              onInput: ($event: any) => (_ctx.info_set_width(index, $event)),
              onChange: ($event: any) => (_ctx.info_set_width(index, $event))
            }, null, 40, _hoisted_17),
            _createElementVNode("input", {
              class: "two_sm_input",
              placeholder: "Введите высоту",
              value: input[1],
              onInput: ($event: any) => (_ctx.info_set_height(index, $event)),
              onChange: ($event: any) => (_ctx.info_set_height(index, $event))
            }, null, 40, _hoisted_18),
            _createElementVNode("button", {
              class: "blue_small_btn",
              style: {"float":"left","margin-left":"15px","margin-top":"0px"},
              onClick: ($event: any) => (_ctx.info_custom_delete(index))
            }, _hoisted_21, 8, _hoisted_19)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "white_s_btn",
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.go_back()))
    }, "Назад"),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["next_btn", { active_btn: _ctx.step_next }]),
      disabled: !_ctx.step_next,
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.go_next()))
    }, " Далее ", 10, _hoisted_22)
  ], 64))
}